@if (show && announcement) {
  <div class="banner pane">
    <div class="content">
      <i class="material-icons announce">stars</i>
      {{ announcement.content }}
    </div>
    <i class="material-icons close" (click)="close()">close</i>
  </div>
}
